import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class AdminLogsBreadCrumbs extends Component {

  render() {
    const { logId } = this.props;
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            <span>Admin</span>
          </div>
          <div className="breadcrumb">
            { logId &&
            <Link to="/admin/logs">Logs</Link>
            }
            { !logId &&
            <span>Logs</span>
            }
          </div>
          { logId &&
          <div className="breadcrumb">
            <span>{logId}</span>
          </div>
          }
        </div>
      </nav>
    )
  }
}

AdminLogsBreadCrumbs.propTypes = {
  logId: PropTypes.string
};
